if (typeof window !== 'undefined' && !window.__mkrTrackingInit_cms8uara2001wvg0zwqpv5t3d) {
  window.__mkrTrackingInit_cms8uara2001wvg0zwqpv5t3d = true;
  
(function() {
  // PostHog SDK stub — init is deferred until consent is confirmed.
  !function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="Ir Sr init jr $r Ci qr Hr Dr capture calculateEventProperties Wr register register_once register_for_session unregister unregister_for_session Qr getFeatureFlag getFeatureFlagPayload getFeatureFlagResult isFeatureEnabled reloadFeatureFlags updateFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey displaySurvey cancelPendingSurvey canRenderSurvey canRenderSurveyAsync tn identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset setIdentity clearIdentity get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException captureLog startExceptionAutocapture stopExceptionAutocapture loadToolbar get_property getSessionProperty Jr Yr createPersonProfile setInternalOrTestUser Kr Pr nn opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing zr debug ki Xr getPageViewId captureTraceFeedback captureTraceMetric Mr".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);

  var _mkrPhToken = 'phc_qbDTSuJCBxyX8CACLOEhPNZBvJVcELuLXGG6J2ibUmK';
  var _mkrPhConfig = {
    api_host: 'https://athena.maker.co',
    ui_host: 'https://us.posthog.com',
    defaults: '2026-01-30',
    person_profiles: 'identified_only',
    name: 'ph_devi_cms8uara2001wvg0zwqpv5t3d',
    autocapture: { css_selector_allowlist: ['[data-tracking-id]'] },
    disable_surveys: true,
    capture_dead_clicks: false,
    loaded: function(posthog) {
      posthog.register({
        mkr_product: 'devi',
        mkr_project_id: 'cms8uara2001wvg0zwqpv5t3d',
        mkr_org_id: 'org_2REc1tnPEsPISxOixJ2l0CV1dpe',
        mkr_organization_name: 'unknown',
        mkr_version: 1787143876470,
        mkr_host_domain: window.__mkr_host_domain || window.location.hostname,
        mkr_host_url: window.__mkr_host_url || window.location.href
      });
      
  var _instanceName = 'ph_devi_cms8uara2001wvg0zwqpv5t3d';
  window.__mkr_ph = window.__mkr_ph || {};
  window.__mkr_ph[_instanceName] = { distinctId: posthog.get_distinct_id(), buckets: {} };
  document.dispatchEvent(new CustomEvent('mkr:ph:ready', { detail: { instanceName: _instanceName, distinctId: window.__mkr_ph[_instanceName].distinctId } }));

    },
  };

  var _mkrPhInited = false;
  var syncPostHogToConsent = function(allowed) {
    if (!allowed) {
      if (_mkrPhInited) posthog.opt_out_capturing();
      return;
    }
    if (_mkrPhInited) {
      posthog.opt_in_capturing();
    } else {
      _mkrPhInited = true;
      posthog.init(_mkrPhToken, _mkrPhConfig);
    }
  };

  // Only an explicit analytics === 'no' from the Shopify CMP denies.
  var readShopifyConsent = function() {
    try {
      var c = window.Shopify.customerPrivacy.currentVisitorConsent();
      return c.analytics !== 'no';
    } catch(e) { return true; }
  };
  var isConsentResolved = function() {
    try {
      var c = window.Shopify.customerPrivacy.currentVisitorConsent();
      return c.analytics === 'yes' || c.analytics === 'no';
    } catch(e) { return false; }
  };

  // Poll Shopify CMP every 100 ms; fail-open after 3 s (handles US stores with no banner).
  var startShopifyConsentPolling = function() {
    var start = Date.now(), resolved = false;
    var interval = setInterval(function() {
      if (resolved) return;
      if (!isConsentResolved() && Date.now() - start < 3000) return;
      clearInterval(interval);
      resolved = true;
      syncPostHogToConsent(readShopifyConsent());
    }, 100);
    document.addEventListener('visitorConsentCollected', function() {
      if (!resolved) { clearInterval(interval); resolved = true; }
      syncPostHogToConsent(readShopifyConsent());
    });
  };

  if (window.parent !== window) {
    // Iframe embed branch — consent signals forwarded by the parent loader via window vars
    // and postMessage. window.__mkr_shopify_cmp / __mkr_gpc / __mkr_accept_cookies are
    // injected into the srcdoc by iframe.ts before embed.js loads.
    if (window.__mkr_gpc) {
      // GPC forwarded from parent — deny, don't init.
    } else if (!window.__mkr_accept_cookies) {
      // Explicit acceptCookies=false forwarded from parent — deny.
    } else if (!window.__mkr_shopify_cmp) {
      // No Shopify CMP on the parent page — allow.
      syncPostHogToConsent(true);
    } else {
      // Shopify CMP detected on parent — default-deny, wait for consent postMessage.
      // Attach listener before posting ready so no message is missed.
      var _mkrIframeConsentReceived = false;
      var _mkrIframeFailOpen = setTimeout(function() {
        if (!_mkrIframeConsentReceived) {
          _mkrIframeConsentReceived = true;
          syncPostHogToConsent(true);
        }
      }, 3000);
      window.addEventListener('message', function(e) {
        if (!e.data || e.data.type !== 'mkr_tracking_consent') return;
        if (!_mkrIframeConsentReceived) {
          clearTimeout(_mkrIframeFailOpen);
          _mkrIframeConsentReceived = true;
        }
        syncPostHogToConsent(e.data.allowed);
      });
      // Tell the parent this listener is ready so it can flush any buffered consent.
      window.parent.postMessage({ type: 'mkr_iframe_consent_ready' }, '*');
    }
  } else {
    // Top-frame branch — simple and org embeds running directly on the customer's page.
    if (navigator.globalPrivacyControl === true) {
      // GPC: first-class deny signal, no init.
    } else if (window.acceptCookies === false) {
      // Explicit acceptCookies=false deny — checked before Shopify CMP so it always wins.
    } else if (!window.Shopify || typeof window.Shopify !== 'object') {
      // Non-Shopify site (or null window.Shopify): no explicit deny → allow.
      syncPostHogToConsent(true);
    } else {
      // Shopify store: auto-detect CMP, poll for consent, subscribe to runtime changes.
      startShopifyConsentPolling();
    }
  }
})();
  
}
import './index.css';
import React, { useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { Topic, Tutorial, topics, tutorials } from './tutorials';
const SEARCH_ICON_URL = 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/magnifying-glass-icon-kb4zodwtex.png';
const CHECKMARK_URL = 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/checkmark-icon-10zb2u9gdr3.png';
const LIBRARY_PATH = '/learn';
const tutorialsByTitle = new Map(tutorials.map(tutorial => [tutorial.title, tutorial]));
const tutorialsBySlug = new Map(tutorials.map(tutorial => [tutorial.slug, tutorial]));
function routeFromLocation() {
  if (typeof window === 'undefined' || !window.location || typeof window.location.pathname !== 'string') {
    return '';
  }
  const match = window.location.pathname.match(/\/learn\/([^/?#]+)/);
  return match ? decodeURIComponent(match[1]) : '';
}
function useProjectNavigation() {
  const [activeSlug, setActiveSlug] = useState(routeFromLocation);
  useEffect(() => {
    const handlePopState = () => setActiveSlug(routeFromLocation());
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);
  const navigate = (path: string) => {
    window.history.pushState({}, '', path);
    setActiveSlug(routeFromLocation());
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  };
  return {
    activeSlug,
    navigate
  };
}
function ClockIcon() {
  return <span className="relative block h-3.5 w-3.5 rounded-full border border-black/40" aria-hidden="true">
    <span className="absolute left-[6px] top-[2px] h-1 w-px bg-black/40" />
    <span className="absolute left-[6px] top-[6px] h-px w-1 rotate-45 origin-left bg-black/40" />
  </span>;
}
function CalendarIcon() {
  return <span className="relative block h-3.5 w-3.5 rounded-[2px] border border-black/40" aria-hidden="true">
    <span className="absolute left-[-1px] right-[-1px] top-[3px] border-t border-black/40" />
    <span className="absolute left-[3px] top-[-2px] h-1 w-px bg-black/40" />
    <span className="absolute right-[3px] top-[-2px] h-1 w-px bg-black/40" />
  </span>;
}
function InternalLink({
  href,
  navigate,
  children,
  className,
  ariaLabel
}: {
  href: string;
  navigate: (path: string) => void;
  children: React.ReactNode;
  className?: string;
  ariaLabel?: string;
}) {
  return <a href={href} onClick={event => {
    if (!event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
      event.preventDefault();
      navigate(href);
    }
  }} className={className} aria-label={ariaLabel} data-tracking-id={`link-a81cc035d70b5cb0_${href}`}>{children}</a>;
}
function VideoCard({
  tutorial,
  navigate,
  related = false
}: {
  tutorial: Tutorial;
  navigate: (path: string) => void;
  related?: boolean;
}) {
  const href = `/learn/${tutorial.slug}`;
  return <InternalLink href={href} navigate={navigate} className="video-card group block min-w-0 rounded-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[10px] focus-visible:outline-black/75" ariaLabel={`${tutorial.title}, ${tutorial.duration}`}>
    <div className="card-thumb relative aspect-video w-full overflow-hidden rounded-lg border border-hairline bg-white">
      <img src={tutorial.thumbnail} alt="" className="h-full w-full object-cover" />
      <span className="card-hover-layer pointer-events-none absolute inset-0 z-10 bg-black/30 opacity-0" />
      <span className={`card-hover-layer pointer-events-none absolute left-1/2 top-1/2 z-20 flex ${related ? 'h-10 w-10' : 'h-12 w-12'} -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-black/60 opacity-0`} aria-hidden="true">
        <span className={`ml-0.5 h-0 w-0 ${related ? 'border-y-[6px] border-l-[10px]' : 'border-y-[7px] border-l-[11px]'} border-y-transparent border-l-white`} />
      </span>
      <span className="absolute bottom-2 right-2 z-30 rounded bg-black/80 px-1 py-1 text-[10px] font-medium leading-[7px] tracking-[.04em] text-white">{tutorial.duration}</span>
    </div>
    <div className="mt-2 flex flex-col gap-1 pb-1">
      {related ? <h3 className="truncate text-sm font-normal leading-[1.3] text-ink group-hover:text-black">{tutorial.title}</h3> : <h2 className="truncate text-sm font-normal leading-[1.3] text-ink group-hover:text-black">{tutorial.title}</h2>}
      <p className="text-xs font-normal leading-[1.3] text-muted">{tutorial.shortDescription}</p>
    </div>
  </InternalLink>;
}
function SearchField({
  value,
  onChange
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  return <label className="search-shell flex h-9 w-full items-center gap-2 rounded-lg border border-hairline bg-white px-3 hover:border-black/15 focus-within:border-black/30 focus-within:shadow-[0_0_0_2px_rgba(0,0,0,.06)]">
    <span className="flex h-6 w-6 shrink-0 items-center justify-center"><img src={SEARCH_ICON_URL} alt="" className="h-6 w-6 object-contain opacity-60" /></span>
    <span className="sr-only">Search videos</span>
    <input type="search" value={value} onChange={event => onChange(event.target.value)} placeholder="Search videos..." className="h-full min-w-0 flex-1 border-0 bg-transparent p-0 text-sm font-normal leading-[1.4] text-ink outline-none placeholder:text-muted" />
  </label>;
}
function TopicFilters({
  selected,
  onToggle
}: {
  selected: Topic[];
  onToggle: (topic: Topic) => void;
}) {
  return <aside className="w-full shrink-0 lg:w-[200px]" aria-labelledby="topics-heading">
    <div className="flex h-9 items-center px-3"><h2 id="topics-heading" className="text-sm font-medium leading-none text-muted">Topics</h2></div>
    <div className="flex flex-col gap-1 p-1 sm:flex-row sm:flex-wrap lg:flex-col">
      {topics.map(topic => {
        const checked = selected.includes(topic);
        return <label key={topic} className="filter-row flex h-8 cursor-pointer items-center gap-2 rounded-md px-2 hover:bg-black/[.04] active:bg-black/[.06] focus-within:bg-black/[.04] sm:w-auto lg:w-48">
          <input type="checkbox" checked={checked} onChange={() => onToggle(topic)} className="sr-only" />
          <span aria-hidden="true" className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-[3px] border ${checked ? 'border-black/90 bg-black/90' : 'border-hairline bg-white'}`}>{checked && <img src={CHECKMARK_URL} alt="" className="h-4 w-4 object-contain" />}</span>
          <span className="whitespace-nowrap text-sm font-normal leading-none text-ink">{topic}</span>
        </label>;
      })}
    </div>
  </aside>;
}
function TutorialLibrary({
  navigate
}: {
  navigate: (path: string) => void;
}) {
  const [query, setQuery] = useState('');
  const [selectedTopics, setSelectedTopics] = useState<Topic[]>([]);
  const filteredTutorials = useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase();
    return tutorials.filter(tutorial => {
      const matchesSearch = !normalizedQuery || tutorial.title.toLowerCase().includes(normalizedQuery) || tutorial.shortDescription.toLowerCase().includes(normalizedQuery);
      const matchesTopic = selectedTopics.length === 0 || selectedTopics.includes(tutorial.topic);
      return matchesSearch && matchesTopic;
    });
  }, [query, selectedTopics]);
  const toggleTopic = (topic: Topic) => setSelectedTopics(current => current.includes(topic) ? current.filter(item => item !== topic) : [...current, topic]);
  useEffect(() => {
    document.title = 'Videos — Maker Resources';
  }, []);
  return <main className="min-h-screen bg-canvas px-4 pb-20 pt-2 sm:px-6">
    <div className="mx-auto w-full max-w-[1112px]">
      <header className="flex h-14 items-center pt-5"><h1 className="text-[32px] font-medium leading-none text-ink sm:text-4xl">Videos</h1></header>
      <div className="mt-8 flex flex-col gap-5 lg:flex-row lg:items-start">
        <section className="min-w-0 flex-1" aria-label="Video library">
          <SearchField value={query} onChange={setQuery} />
          <div className="mt-5 lg:hidden"><TopicFilters selected={selectedTopics} onToggle={toggleTopic} /></div>
          {filteredTutorials.length > 0 ? <div className="mt-5 grid grid-cols-1 gap-x-5 gap-y-8 sm:grid-cols-2 xl:grid-cols-3" aria-live="polite">
            {filteredTutorials.map(tutorial => <VideoCard key={tutorial.id} tutorial={tutorial} navigate={navigate} />)}
          </div> : <div className="mt-5 rounded-lg border border-hairline bg-white px-6 py-12 text-center">
            <p className="text-sm text-ink">No videos found</p><p className="mt-1 text-xs leading-[1.3] text-muted">Try another search or clear a topic filter.</p>
          </div>}
        </section>
        <div className="hidden lg:block"><TopicFilters selected={selectedTopics} onToggle={toggleTopic} /></div>
      </div>
    </div>
  </main>;
}
function parseIsoDuration(duration: string): string {
  const parts = duration.split(':').map(Number);
  if (parts.length === 2) {
    return `PT${parts[0]}M${parts[1]}S`;
  }
  if (parts.length === 3) {
    return `PT${parts[0]}H${parts[1]}M${parts[2]}S`;
  }
  return 'PT1M';
}
function parseIsoDate(dateStr: string): string {
  const date = new Date(dateStr);
  return isNaN(date.getTime()) ? '2025-01-01T00:00:00Z' : date.toISOString();
}
function TutorialDetail({
  tutorial,
  navigate
}: {
  tutorial: Tutorial;
  navigate: (path: string) => void;
}) {
  const relatedTutorials = tutorial.related.map(title => tutorialsByTitle.get(title)).filter((item): item is Tutorial => Boolean(item));
  useEffect(() => {
    document.title = `${tutorial.title} — Maker Resources`;
  }, [tutorial.slug]);
  const videoSchema = {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    'name': tutorial.title,
    'description': tutorial.shortDescription || tutorial.description1,
    'thumbnailUrl': [tutorial.mainThumbnail, tutorial.thumbnail],
    'uploadDate': parseIsoDate(tutorial.publicationDate),
    'duration': parseIsoDuration(tutorial.duration),
    'contentUrl': tutorial.vimeoUrl,
    'embedUrl': `https://player.vimeo.com/video/${tutorial.vimeoId}?app_id=122963`
  };
  return <main className="min-h-screen bg-canvas px-4 pb-20 pt-4 font-geist sm:px-6 md:pt-8">
    <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(videoSchema)
    }} />
    <article className="mx-auto w-full max-w-[1112px]">
      <nav aria-label="Breadcrumb" className="flex min-h-[14px] items-center justify-between gap-6 text-sm font-medium leading-none">
        <div className="flex min-w-0 items-center gap-2.5">
          <InternalLink href={LIBRARY_PATH} navigate={navigate} className="shrink-0 text-muted transition-colors hover:text-ink focus-visible:rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-black/60">All videos</InternalLink>
          <span className="shrink-0 text-muted" aria-hidden="true">/</span>
          <span className="truncate text-ink">{tutorial.title}</span>
        </div>
        <InternalLink href={LIBRARY_PATH} navigate={navigate} className="group flex shrink-0 items-center gap-[5px] text-sm font-medium leading-none text-muted transition-colors hover:text-ink focus-visible:rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-black/60" ariaLabel="Go back to all videos">
          <span className="group-hover:underline">Go back</span><span className="text-xs" aria-hidden="true">↵</span>
        </InternalLink>
      </nav>

      <section className="mt-4 overflow-hidden rounded-lg" style={{
        border: '1px solid #000000'
      }} aria-label="Video player">
        <div className="relative aspect-video w-full bg-black">
          <iframe src={`https://player.vimeo.com/video/${tutorial.vimeoId}?app_id=122963`} className="h-full w-full" title={tutorial.title} allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen />
        </div>
      </section>

      <div className="mt-6 flex flex-col items-start justify-between gap-8 pb-3 md:flex-row md:gap-6">
        <section className="w-full md:w-[480px]">
          <h1 className="text-[32px] font-medium leading-none text-ink sm:text-4xl">{tutorial.title}</h1>
          <div className="mt-6 flex flex-col gap-2 text-sm font-normal leading-[1.5] text-muted"><p>{tutorial.description1}</p><p>{tutorial.description2}</p></div>
        </section>
        <aside className="w-full rounded-lg md:w-[240px]" aria-label="Video information">
          <h2 className="px-3 py-2 text-sm font-medium leading-none text-muted">Video details</h2>
          <div className="flex h-7 items-center gap-2 px-3 py-0.5 text-xs leading-[1.4] text-muted"><span className="flex h-6 w-6 shrink-0 items-center justify-center"><ClockIcon /></span><span>{tutorial.duration}</span></div>
          <div className="flex h-7 items-center gap-2 px-3 py-0.5 text-xs leading-[1.4] text-muted"><span className="flex h-6 w-6 shrink-0 items-center justify-center"><CalendarIcon /></span><time>{tutorial.publicationDate}</time></div>
          <div className="mx-3 my-3 border-t border-[#E6E6E6]" />
          <h2 className="px-3 pb-2 text-sm font-medium leading-none text-muted">Related article</h2>
          <a href={tutorial.docsUrl} target="_blank" rel="noreferrer" className="block px-3 py-1 text-sm font-normal leading-[1.4] text-black/80 transition-colors hover:text-ink hover:underline focus-visible:rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-black/60" data-tracking-id={`link-4a40ceeb49860aeb_${tutorial.slug}`}>{tutorial.docsTitle}</a>
        </aside>
      </div>

      <div className="mt-6 border-t border-hairline" />
      <section className="mt-6" aria-labelledby="related-videos-heading">
        <h2 id="related-videos-heading" className="text-sm font-medium leading-none text-muted">Related videos</h2>
        <div className="mt-4 grid grid-cols-1 gap-x-5 gap-y-8 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
          {relatedTutorials.map(item => <VideoCard key={item.id} tutorial={item} navigate={navigate} related />)}
        </div>
      </section>
    </article>
  </main>;
}
export default function App() {
  const {
    activeSlug,
    navigate
  } = useProjectNavigation();
  const tutorial = activeSlug ? tutorialsBySlug.get(activeSlug) : undefined;
  return tutorial ? <TutorialDetail tutorial={tutorial} navigate={navigate} /> : <TutorialLibrary navigate={navigate} />;
}
ReactDOM.createRoot(document.getElementById("cms8uara2001wvg0zwqpv5t3d-root")!).render(<React.StrictMode><App /></React.StrictMode>);